import React from "react";
import { LinkBox, LinkOverlay, useMediaQuery } from "@chakra-ui/react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Link,
} from "@chakra-ui/react";
import { CardsModuleProps } from "../../types/homePageTypes";
import "./cards.scss";

// 2 Card Layout

const Cards = ({ title, articleItems }: CardsModuleProps) => {
  const [isLargerThan1200] = useMediaQuery("(min-width: 1200px)");

  // case: not enough cards
  if (articleItems.length < 2) {
    console.log(`Section "${title}" is not importing enough cards to build the module. Please check Contentful for proper selection of grid layout or that the right number of cards has been added to the object.`);
  }

  // case: too many cards, cutoff at needed amount
  const MAX_CARDS = 2;
  let finalCards = articleItems;
  if (articleItems.length > MAX_CARDS) {
    finalCards = articleItems.slice(0, MAX_CARDS);
  }

  return (
    <Flex
      className="cards-2"
      direction={{ base: "column", xl: "row" }}
      gap="10px"
      p="0 10px"
      marginTop="10px !important"
      marginBottom={{ base: "50px !important", sm: "80px !important" }}
    >
      {finalCards.map(( card, index ) => {
        return (
          <Box
            key={ index }
            w="100%"
            h={{ base: "220px", sm: "375px", xl: "456px", "3xl": "550px" }}
            backgroundImage={ card.imageUrl }
            aria-label={ card.imageAlt }
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundPosition="center"
          >
            <LinkBox
              display="flex" 
              w="100%" 
              h="100%"
              p={{ base: "24px 24px", sm: "44px 51px", "2xl": "56px 93px" }}
              flexDirection="column"
              justifyContent="flex-end !important"
              alignItems="flex-start !important" 
              background="linear-gradient(rgba(0, 0, 0, 0.31), rgba(0, 0, 0, 0.31))"
            >
              <LinkOverlay href={ card.slug } aria-label={card.buttonText}>
                {/* heading */}
                {card.title &&
                  <Box
                    marginBottom={{ base: "12px", sm: "20px", xl: "28px" }}
                  >
                    <Heading
                      as="h3"
                      size={{ base: "cards-header-mobile", sm: "cards-header-tablet", xl: "cards-header" }}
                      textAlign="left"
                    >
                      { card.title }
                    </Heading>
                  </Box>
                }

                {/* button */}
                {card.buttonText &&
                  <>
                    {index === 0 &&
                      <Button
                        size={{ base: "2-card-mobile", sm: "2-card" }}
                        backgroundColor="#E31D40"
                        _hover={ isLargerThan1200 ? { bgColor: "#000000 !important" } : { bgColor: "none" }}
                      >
                        { card.buttonText }
                      </Button>
                    
                    }
                    {!(index === 0) &&
                      <Button
                        size={{ base: "2-card-mobile", sm: "2-card" }}
                        backgroundColor="#337AB3"
                        _hover={ isLargerThan1200 ? { bgColor: "#FFFFFF !important", color: "#000000 !important" } : { bgColor: "none" }}
                      >
                        { card.buttonText }
                      </Button>
                    }
                  </>
                }
              </LinkOverlay>
            </LinkBox>
          </Box>
        )
      })}
    </Flex>
  );
}

export default Cards;